var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 259,
    viewBox: "0 0 259 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_2797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.304 165.139L173.401 152.305L173.414 152.234L116.651 70.8138L105.56 78.5796L162.298 160.142L162.311 160.071L175.304 165.139Z",
    fill: "url(#paint0_linear_344_2797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.088 174.21L160.185 161.375L160.114 161.363L103.435 79.8841L92.3439 87.6499L149.081 169.212L162.088 174.21Z",
    fill: "url(#paint1_linear_344_2797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.59 183.598L146.686 170.764L146.615 170.751L89.9363 89.2726L78.7748 97.0258L135.512 178.588L135.596 178.529L148.59 183.598Z",
    fill: "url(#paint2_linear_344_2797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.335 100.809L136.139 20.8181L118.929 70.3371L174.866 150.223C175.053 150.402 175.362 150.31 175.362 150.31L243.941 102.54L160.335 100.809Z",
    fill: "url(#paint3_linear_344_2797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1511 98.0952L91.7543 148.578L64.3154 227.504L132.965 179.746L133.061 179.617L77.0113 99.1263L25.1511 98.0952Z",
    fill: "url(#paint4_linear_344_2797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.574 230.23L148.05 221.072L162.527 218.142L199.574 230.23Z",
    fill: "url(#paint5_linear_344_2797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.215 192.705L169.603 208.72L199.579 230.232C199.579 230.232 189.567 197.475 188.215 192.705Z",
    fill: "#1E417C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_2797",
    x1: 111.647,
    y1: 75.3168,
    x2: 173.701,
    y2: 164.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0571262,
    stopColor: "#FAEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1712,
    stopColor: "#EEC0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    stopColor: "#D97681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5023,
    stopColor: "#C22032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_344_2797",
    x1: 98.4572,
    y1: 84.4726,
    x2: 160.512,
    y2: 173.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0571262,
    stopColor: "#FAEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1712,
    stopColor: "#EEC0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    stopColor: "#D97681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5023,
    stopColor: "#C22032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_344_2797",
    x1: 84.9439,
    y1: 93.8495,
    x2: 146.998,
    y2: 183.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0571262,
    stopColor: "#FAEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1712,
    stopColor: "#EEC0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3317,
    stopColor: "#D97681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5023,
    stopColor: "#C22032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_344_2797",
    x1: 112.184,
    y1: -21.2444,
    x2: 197.963,
    y2: 112.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EAACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9576,
    stopColor: "#1E417C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_344_2797",
    x1: 0.375634,
    y1: 50.6553,
    x2: 86.1555,
    y2: 184.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EAACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9576,
    stopColor: "#1E417C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_344_2797",
    x1: 159.688,
    y1: 220.347,
    x2: 190.472,
    y2: 231.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A747C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_2797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223.433,
    height: 223.433,
    fill: "white",
    transform: "translate(38.7986) rotate(10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginStar);
export default __webpack_public_path__ + "static/media/login_star.2edc1d381b65034d245c40c543f215cf.svg";
export { ForwardRef as ReactComponent };